import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './event-list-filter-year-topic.component.scss';
var EventListFilterYearTopic = /** @class */ (function (_super) {
    tslib_1.__extends(EventListFilterYearTopic, _super);
    function EventListFilterYearTopic(element) {
        return _super.call(this, element) || this;
    }
    EventListFilterYearTopic.prototype.init = function () { };
    ;
    EventListFilterYearTopic.prototype.bindEvents = function () { };
    ;
    return EventListFilterYearTopic;
}(Base));
export { EventListFilterYearTopic };



//////////////////
// WEBPACK FOOTER
// ./components/event-list-filter-year-topic/event-list-filter-year-topic.component.ts
// module id = 271
// module chunks = 0